import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ConversationState {
  inputMessage: string;
  isLoading: boolean;
  isLiveChatting: boolean;
  isAssistantSpeaking: boolean;
  isUserSpeaking: boolean;
  isManuallyRecording: boolean;
  isWebSocketReady: boolean;
}

const initialState: ConversationState = {
  inputMessage: "",
  isLoading: false,
  isLiveChatting: false,
  isAssistantSpeaking: false,
  isUserSpeaking: false,
  isManuallyRecording: false,
  isWebSocketReady: false,
};

export const conversationSlice = createSlice({
  name: "conversation",
  initialState,
  reducers: {
    setInputMessage: (state, action: PayloadAction<string>) => {
      state.inputMessage = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsLiveChatting: (state, action: PayloadAction<boolean>) => {
      state.isLiveChatting = action.payload;
    },
    setIsAssistantSpeaking: (state, action: PayloadAction<boolean>) => {
      state.isAssistantSpeaking = action.payload;
    },
    setIsUserSpeaking: (state, action: PayloadAction<boolean>) => {
      state.isUserSpeaking = action.payload;
    },
    setIsManuallyRecording: (state, action: PayloadAction<boolean>) => {
      state.isManuallyRecording = action.payload;
    },
    setIsWebSocketReady: (state, action: PayloadAction<boolean>) => {
      state.isWebSocketReady = action.payload;
    },
  },
});

export const {
  setInputMessage,
  setIsLoading,
  setIsLiveChatting,
  setIsAssistantSpeaking,
  setIsUserSpeaking,
  setIsManuallyRecording,
  setIsWebSocketReady,
} = conversationSlice.actions;

export default conversationSlice;
